import * as React from 'react';
import Button from 'react-bootstrap/Button';
import classnames from 'classnames';

import './style.scss';

interface ICopyButtonProps {
  onClick: TButtonOnClick;
  className?: string;
}

interface ICopyButtonState {}

export default class CopyButton extends React.Component<ICopyButtonProps, ICopyButtonState> {
  static defaultProps: ICopyButtonProps = {
    onClick: () => null,
    className: '',
  };

  render() {
    const { onClick, className } = this.props;

    return <Button className={classnames('copy-btn', className)} onClick={(event) => onClick(event)} />;
  }
}
